import React from 'react';
import Icon from 'components/Icon/Icon';

const CheckBox = ({
  checked = true,
  error = false,
  onClick,
  style,
  tickColor = '#399ef8',
  size = '30px',
  ...rest
}) => (
  <div onClick={onClick} style={{ ...style, cursor: 'pointer' }} {...rest}>
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '4px',
        WebkitBorderRadius: '4px',
        MozBorderRadius: '4px',
        padding: 0,
        margin: 0,
        textAlign: 'center',
        lineHeight: size,
        border: error ? '1px solid #d9534f' : '1px solid #ccc',
        boxShadow: error
          ? '0px 1px 3px rgba(0, 0, 0, 0.05) inset, 0px 0px 8px #d9534f'
          : 'none',
        userSelect: 'none',
      }}
    >
      {checked && <Icon icon="&#xe60c;" color={tickColor} />}
    </div>
  </div>
);

export default CheckBox;
